import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "image-preview" };
const _hoisted_2 = {
    key: 0,
    class: "d-none",
    id: "premium-badge",
    src: "/images/prem.png"
};
const _hoisted_3 = {
    key: 1,
    class: "watermark"
};
const _hoisted_4 = { class: "color-mask watercolor-shape" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "calendar-preview mx-auto p-2" };
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue3';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
import { useCalendarTemplatesStore } from '../stores/calendarTemplates';
import { useCalendarImagesStore } from '../stores/calendarImages';
import { useInitStore } from '../stores/init';
import ImageUpload from '../components/ImageUpload.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'WatercolorTemplate',
    setup(__props) {
        _useCssVars(_ctx => ({
            "47b44af9": (_unref(calendarTemplatesStore).templates[1].settings.shapeColor),
            "b47561ae": (_unref(calendarTemplatesStore).templates[1].settings.shapeSize + '%')
        }));
        const calendarSettingsStore = useCalendarSettingsStore();
        const calendarTemplatesStore = useCalendarTemplatesStore();
        const calendarImagesStore = useCalendarImagesStore();
        const initStore = useInitStore();
        calendarSettingsStore.title.fontFace.fontName = 'Brusher';
        calendarSettingsStore.title.fontSize = 80;
        calendarSettingsStore.title.shadowColor = '#ffffff';
        calendarSettingsStore.setDayNames('narrow');
        calendarSettingsStore.calendarOptions.titleFormat = { year: undefined, month: 'long' };
        calendarTemplatesStore.templateIndex = 1;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(ImageUpload, { imageIndex: 0 }),
                    (!_unref(initStore).isLoggedIn)
                        ? (_openBlock(), _createElementBlock("img", _hoisted_2))
                        : _createCommentVNode("", true),
                    (_unref(calendarImagesStore).imageSelected)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_3, "CustomCalendarMaker.com"))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("img", {
                        class: "masked-image",
                        src: '/images/shapes/watercolor/' + _unref(calendarTemplatesStore).templates[1].settings.shapeFile
                    }, null, 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(_unref(FullCalendar), {
                        ref: "fullcalendar",
                        options: _unref(calendarSettingsStore).calendarOptions
                    }, null, 8, ["options"])
                ])
            ], 64));
        };
    }
});
